import { COLOR } from 'src/constants/colors'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useTranslation } from 'react-i18next'
import { LocationDataPropsType } from 'src/views/Service/Location'
import Div from 'src/components/atomic/atom/Div'
import Span from 'src/components/atomic/atom/Span'
import Svg from 'src/components/atomic/atom/Svg'
import Section from 'src/components/atomic/atom/Section'
import { setMapCenterPosition } from 'src/store/Reducer/page/locationPageSlice'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
// XVal,YVal, Address 이외에는 임의의 값으로 객체 설정
export const CurrentLocationTempObject: {
  Idx: number
  ImageIdx: number
  Type: 1
  FImage: string
  BImage: string
} = {
  Idx: -1,
  Type: 1,
  ImageIdx: -1,
  FImage: '',
  BImage: '',
}

const LocationCurrentInfo = (props: { data: LocationDataPropsType }) => {
  const dispatch = useAppDispatch()
  const { getLocationTotalData, onLocationHistoryClick } = props.data
  const { setMediaStyle } = useMediaQueryHook()
  const { t } = useTranslation()
  const { XVal, YVal, Address, Date } = useAppSelector((state: RootState) => state.currentLocation)

  const CurrentLocationObject = {
    ...CurrentLocationTempObject,
    XVal: XVal,
    YVal: YVal,
    Address: Address,
    Date: Date,
  }
  return (
    <Div
      $bgColor={COLOR.black4}
      $border_radius={'12px'}
      $padding={setMediaStyle('14px 16px', '16px 20px', '16px 20px')}
      $margin={setMediaStyle('20px 0', '16px 0', '16px 0 20px 0')}
    >
      <Section display={'flex'} $justify_content={'space-between'}>
        <Span
          option={'small_bold'}
          ellipsis={3}
          $margin={'0 auto'}
          $text_align={Address === '' ? 'center' : 'left'}
          style={{ width: '100%' }}
        >
          {Address !== ''
            ? Address
            : t('LOCATE.UNKNOWN', { defaultValue: 'Current Location Unknown' })}
        </Span>
        {Address && (
          <Svg
            name={'arrow'}
            color={COLOR.black80}
            onClick={() => {
              onLocationHistoryClick(CurrentLocationObject)
              dispatch(
                setMapCenterPosition({
                  lat: Number(CurrentLocationObject.XVal),
                  lng: Number(CurrentLocationObject.YVal),
                }),
              )
            }}
            style={{ padding: setMediaStyle('0  16px  0 10px', '0 20px 0 10px', '0 20px 0 10px') }}
          />
        )}
      </Section>
      <Svg
        name={'location_reload'}
        width={setMediaStyle('24', '24', '32')}
        height={setMediaStyle('24', '24', '32')}
        onClick={getLocationTotalData}
        $margin={'6px auto 0 auto'}
        style={{ width: '24px' }}
      />
    </Div>
  )
}

export default LocationCurrentInfo
